import axios, { type AxiosRequestConfig } from "axios";
import axiosRetry from "axios-retry";

import { axiosRetryConfig } from "./GenericAPI";
import config from "config";
import StorageUtil, { KEYS } from "helpers/utils/StorageUtil";


export default class BaseAPI {
  /**Métodos get */
  static async get(endpoint: string, data = {}) {
    const requestConfig = { params: data };
    return await api.get(endpoint, requestConfig);
  }

  /**Métodos post */
  static async post(endpoint: string, data = {}) {
    return await api.post(endpoint, data);
  }

  /**Método Put */
  static async put(endpoint: string, data = {}) {
    return await api.put(endpoint, data);
  }

  /**Método Patch */
  static async patch(endpoint: string, data = {}, config: AxiosRequestConfig) {
    return await api.patch(endpoint, data, config);
  }

  /**Método delete */
  static async delete(endpoint: string, data = {}) {
    return await api.delete(endpoint, { data });
  }
}

const api = axios.create({
  baseURL: config.url,
});

api.interceptors.request.use(
  (config) => {
    const token = StorageUtil.getItem(KEYS.LOCKER_TOKEN);
    const companyUuid = StorageUtil.getItem(KEYS.COMPANY_UUID);

    config.headers.set(
      'Content-Type',
      config.data instanceof FormData
        ? "multipart/form-data; charset=utf-8"
        : "application/json; charset=utf-8"
    );
    config.headers.set('accept', "*/*");
    config.headers.set('X-Company-UUID', companyUuid);

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosRetry(api, axiosRetryConfig);
